import './blog_navigation';
import './blog_search';



// WEBPACK FOOTER //
// ./javascripts/components/legacy/blog/blog_index.js